import Swiper, { Keyboard, SwiperOptions, Navigation, Thumbs } from "swiper";
import { lazyLoading } from "../../../js/lazyload/lazyload-init"
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js"
import cs from "@fancyapps/ui/src/Fancybox/l10n/cs"

export { }

const galleries = document.querySelectorAll<HTMLElement>(".pd-gallery")

galleries.forEach(gallery => {
  const thumbnails = gallery.querySelector<HTMLElement>(".g-thumbnails")
  const heros = gallery.querySelector<HTMLElement>(".g-heros")

  if (!heros || !thumbnails) return

  const prevButton = thumbnails.querySelector<HTMLElement>(".swiper-button-prev")
  const nextButton = thumbnails.querySelector<HTMLElement>(".swiper-button-next")

  const thumbnailSettings: SwiperOptions = {
    modules: [Keyboard],
    spaceBetween: 0,
    keyboard: {
      enabled: true,
    },
    slidesPerView: "auto",
    loop: true,
    watchSlidesProgress: true,
    on: {
      slideChange: () => {
        lazyLoading.update()
      }
    },
    breakpoints: {
      0: {
        direction: "horizontal",
      },
      767: {
        direction: "vertical",
      }
    }
  }

  const thumbnailSwiper = new Swiper(thumbnails, thumbnailSettings)

  const herosSettings: SwiperOptions = {
    modules: [Keyboard, Thumbs, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: thumbnailSwiper
    },
    loop: true,
    on: {
      init: () => {
        gallery.classList.remove("--loading")
      },
    },
  }

  const heroSwiper = new Swiper(heros, herosSettings)

  heroSwiper.on("slideChange", () => {
    prevButton?.classList.remove("--hidden")
  })

  const fancyboxSettings = {
    id: 'hero-gallery',
    l10n: cs,
    groupAll: true,
    Image: {
      zoom: false,
    },
    Toolbar: {
      display: ["close"],
    },
    on: {
      shouldClose: function () {
        const activeItem = document.querySelector(".is-nav-selected")
        const index = Number(activeItem?.getAttribute("data-index"))
        heroSwiper.slideTo(index, 0)
      },
    },
  }

  Fancybox.bind(`.pd-i-hero[data-fancybox-gallery=hero-gallery]`, fancyboxSettings)
})
